import { utilitiesImg2, utilitiesImg3, utilitiesImg4} from "../../assets/images/index.js";

export const utilitiesData = [
  {
    title: "Schedule messages with Timers",
    paragraph:
      "Send timed messages - both text or embed - every specific time on every specific day. Use the timed messages to remind your members about your rules or an upcoming event.",
    showDiscordButton: true,
    image: utilitiesImg2,
    imagePosition: "right",
  },
  {
    title: "Display server statistics",
    paragraph:
      "Count your members and followers on your social media, and display those numbers on the sidebar of your Discord server. We also have available Web3 statistics for NFT projects and Crypto currencies.",
    showDiscordButton: true,
    image: utilitiesImg3,
    imagePosition: "left",
  },
  {
    title: "Unique Discord temporary channels",
    paragraph:
      "Allow your members to create temporary voice channels to play together and have their own private space, by clicking just one button. The channel will get automatically deleted after everyone leaves. That way you can keep your server clean.",
    showDiscordButton: true,
    image: utilitiesImg4,
    imagePosition: "right",
  },
  
];
